// extracted by mini-css-extract-plugin
export default {"item-list":"FriedDesktop_item-list__LZRS8","item":"FriedDesktop_item__Bbr2p","category-title":"FriedDesktop_category-title__HaCCo"};